import { INTEGRATED_LOAD_DETAIL_VIEW_TAB } from '~/src/components/RyderShare/TrackingPage/LoadDetailView/constants'
import { INTEGRATED_SHIPMENT_DETAIL_VIEW_TAB } from '~/src/components/RyderShare/TrackingPage/ShipmentDetailView/constants'

type FacilityUrlProps = {
  id: bigint
}

type UrlProps = {
  id: number
  tab?: string
}

export const OperatorLoadBasePath = '/all-loads'
export const DataManagementBasePath = '/datamanagement'
export const CustomerLoadBasePath = '/rydershare/visibility'
export const CustomerExceptionsPath = '/rydershare/visibility/exceptions'
export const TmExceptionsPath = '/shipments/exceptions'
export const ShipmentBasePath = '/shipments'

export const RydershareBasePath = 'https://www.rydershare.com'
export const IntegratedTrackingBasePath = '/tracking'
export const IntegratedExceptionsPath = '/tracking/exceptions'
export const NetworkBasePath = '/network'
export const ActiveLoadsBasePath = '/monitor/active-loads'
export const ReviewLoadsBasePath = '/review/sign-off'
export const EfficiencyManagementBasePath = '/review/efficiency-management'
export const PlanLoadsBasePath = '/plan/load-entry'
export const HomePath = '/home'

export const EXCEPTIONS_PATHS = [
  CustomerExceptionsPath,
  TmExceptionsPath,
  IntegratedExceptionsPath,
] as const

const Urls = {
  login: () => '/login',
  facility: ({ id }: FacilityUrlProps) => `${DataManagementBasePath}/facilities/${id}`,
  tractor: ({ id }: UrlProps) => `${DataManagementBasePath}/tractors/${id}`,
  trailer: ({ id }: UrlProps) => `${DataManagementBasePath}/trailers/${id}`,
  operatorLoad: ({ id, tab }: UrlProps) =>
    tab ? `${OperatorLoadBasePath}/${id}?tab=${tab}` : `${OperatorLoadBasePath}/${id}`,
  customerLoad: ({
    id,
    tab = INTEGRATED_LOAD_DETAIL_VIEW_TAB.Load,
  }: UrlProps & { tab?: INTEGRATED_LOAD_DETAIL_VIEW_TAB }) =>
    `${CustomerLoadBasePath}/${id}?tab=${tab}`,
  shipment: ({
    id,
    tab = INTEGRATED_SHIPMENT_DETAIL_VIEW_TAB.Details,
  }: UrlProps & { tab?: INTEGRATED_SHIPMENT_DETAIL_VIEW_TAB }) =>
    `${ShipmentBasePath}/${id}?tab=${tab}`,
  shipmentLoad: ({
    id,
    loadId,
    tab = INTEGRATED_LOAD_DETAIL_VIEW_TAB.Load,
  }: UrlProps & {
    loadId: number
    tab?: INTEGRATED_LOAD_DETAIL_VIEW_TAB
  }) => `${ShipmentBasePath}/${id}/load/${loadId}?tab=${tab}`,
  rydershare: () => `${RydershareBasePath}/landing`,
  integratedTracking: () => `${IntegratedTrackingBasePath}`,
  integratedLoad: ({
    id,
    tab = INTEGRATED_LOAD_DETAIL_VIEW_TAB.Load,
  }: UrlProps & { tab?: INTEGRATED_LOAD_DETAIL_VIEW_TAB }) =>
    `${IntegratedTrackingBasePath}/load/${id}?tab=${tab}`,
  integratedLoadShipment: ({
    id,
    shipmentId,
    tab = INTEGRATED_SHIPMENT_DETAIL_VIEW_TAB.Details,
  }: UrlProps & {
    shipmentId: number
    tab?: INTEGRATED_SHIPMENT_DETAIL_VIEW_TAB
  }) => `${IntegratedTrackingBasePath}/load/${id}/shipment/${shipmentId}?tab=${tab}`,
  integratedShipment: ({
    id,
    tab = INTEGRATED_SHIPMENT_DETAIL_VIEW_TAB.Details,
  }: UrlProps & { tab?: INTEGRATED_SHIPMENT_DETAIL_VIEW_TAB }) =>
    `${IntegratedTrackingBasePath}/shipment/${id}?tab=${tab}`,
  integratedShipmentLoad: ({
    id,
    loadId,
    tab = INTEGRATED_LOAD_DETAIL_VIEW_TAB.Load,
  }: UrlProps & {
    loadId: number
    tab?: INTEGRATED_LOAD_DETAIL_VIEW_TAB
  }) => `${IntegratedTrackingBasePath}/shipment/${id}/load/${loadId}?tab=${tab}`,
  activeLoad: ({ id, tab }: UrlProps) =>
    tab
      ? `${ActiveLoadsBasePath}/loads/${id}?tab=${tab}`
      : `${ActiveLoadsBasePath}/loads/${id}`,
  signOffLoad: ({ id, tab }: UrlProps) =>
    tab
      ? `${ReviewLoadsBasePath}/loads/${id}?tab=${tab}`
      : `${ReviewLoadsBasePath}/loads/${id}`,
  planLoad: ({ id }: UrlProps) => `${PlanLoadsBasePath}/loads/${id}`,
  efficiencyManagementDriver: ({ id }: { id: number }) =>
    `${EfficiencyManagementBasePath}/drivers/${id}`,
  network: () => `${NetworkBasePath}`,
  networkLoad: ({
    id,
    tab = INTEGRATED_LOAD_DETAIL_VIEW_TAB.Load,
  }: UrlProps & { tab?: INTEGRATED_LOAD_DETAIL_VIEW_TAB }) =>
    `${NetworkBasePath}/load/${id}?tab=${tab}`,
}

export { Urls }
